import { render, staticRenderFns } from "./View21.vue?vue&type=template&id=c873a3e6&scoped=true&"
import script from "./View21.vue?vue&type=script&lang=js&"
export * from "./View21.vue?vue&type=script&lang=js&"
import style0 from "./View21.vue?vue&type=style&index=0&id=c873a3e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c873a3e6",
  null
  
)

export default component.exports